<template>
  <div class="short-answer" id="shortAnswer">
    <div class="ui-layout-west border0 padding0" v-resize="this.resize">
      <div class="item-title pr">
        <div class="item-head-title">
          <span>资料区</span>
          <div class="pull-right">
            <button class="min-btn" @click="toggleWin('left')"><i></i>{{magnifyText}}</button>
          </div>
        </div>
        <div class="item-ques" v-html="currentQuestion.content">
        </div>
      </div>
    </div>
    <div class="ui-layout-center border0 padding0" ref="rightChildQuestion">
      <div class="item-title pr">
        <div class="item-head-title">
          <span>作答区</span>
          <div class="pull-right">
            <button class="min-btn" @click="toggleWin('right')"><i></i>{{magnifyText}}</button>
          </div>
        </div>
      </div>
      <div class="sa-input" ref="saInput" v-if="currentQuestion.smallContent[0].quesTypeID === 4 || currentQuestion.smallContent[0].quesTypeID === 5">
        <div class="clearfix">
          <div v-for="(item,idx) in currentQuestion.smallContent"
               @click="smallClick(idx)"
               class="smallContent pr"
               :key="idx"
               :id="'smallId'+item.newNum">
            <div class="quesContent" ref="quesContent">
              <p class="sa-title">
                <span class="smallNum">{{ item.newNum }}</span><span v-html="item.content"></span>
              </p>
              <div class="editor pr"
                   :class="{ 'actived' : smallIndex === idx}"
                   :ref="'editor'+item.questionID">
                <div class="sa-function clearfix"
                     v-if="currentQuestion.quesTypeID === 4 || currentQuestion.quesTypeID === 5">
                  <ul class="">
                    <li>
                      <el-tooltip effect="dark" content="复制" placement="top">
                        <a href="javascript:void(0)" @click="copyFn">
                          <img src="@/assets/images/formula/icon-copy.png" alt="">
                        </a>
                      </el-tooltip>
                    </li>
                    <li>
                      <el-tooltip effect="dark" content="剪切" placement="top">
                        <a href="javascript:void(0)" @click="cutFn">
                          <img src="@/assets/images/formula/icon-cut.png" alt="">
                        </a>
                      </el-tooltip>
                    </li>
                    <li>
                      <el-tooltip effect="dark" content="粘贴" placement="top">
                        <a href="javascript:void(0)" @click="pasteFn">
                          <img src="@/assets/images/formula/icon-paste.png" alt="">
                        </a>
                      </el-tooltip>
                    </li>
                    <li>
                      <el-tooltip effect="dark" content="插入公式符号" placement="top">
                        <a href="javascript:void(0)" @click="openFormula(idx)">
                          <img src="@/assets/images/formula/icon-gs.png" alt="">
                        </a>
                      </el-tooltip>
                      <formula :visible.sync="visibleFm[idx]" @toggleFn="insertWrite($event,idx)"/>
                    </li>
                   <!-- <li>
                      <el-tooltip effect="dark" content="插入表格矩阵" placement="top">
                        <a href="javascript:void(0)" @click="openTable(idx)">
                          <img src="@/assets/images/formula/icon-jz.png" alt="">
                        </a>
                      </el-tooltip>
                      <matrix :visible.sync="visibleTable[idx]" @toggleTable="insertMatrix" @delTable="deleteTable"/>
                    </li>-->
                    <li>
                      <el-tooltip effect="dark" content="插入表格矩阵" placement="top">
                        <a href="javascript:void(0)" @click="openTableFun(idx)">
                          <img src="@/assets/images/formula/icon-jz.png" alt="">
                        </a>
                      </el-tooltip>
                    </li>
                  </ul>
                </div>
                <div class="answerArea"
                     v-if="item.questionID"
                     v-html="checkHtml(item.attAnswer) !== '' ? (checkHtml(item.userAnswer) !== '' ? checkHtml(item.userAnswer) : checkHtml(item.attAnswer)) : checkHtml(item.userAnswer)"
                     :ref="'hasChildAnswerArea' + item.questionID"
                     :id="'answerArea' + item.questionID"
                     :qid="item.questionID"
                     :smallIndex="idx"
                     contenteditable="true"
                     @mouseup="mouseUpFn">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="sa-input sa-input-simple" ref="saInput" v-else>
        <div class="quesContent quesContent-simple" ref="quesContent">
          <div v-for="(smallContent,index) in currentQuestion.smallContent" @click="smallClick(index)">
            <!-- 单选题、判断题 -->
            <template v-if="smallContent.quesTypeID === 1 || smallContent.quesTypeID === 3">
              <exam-single-choice-simple
                :id="'smallId'+smallContent.newNum"
                :key="index"
                :idx="index"
              ></exam-single-choice-simple>
            </template>
            <!-- 多选题 -->
            <template v-if="smallContent.quesTypeID === 2">
              <exam-multiple-choice-simple
                :id="'smallId'+smallContent.newNum"
                :key="index"
                :idx="index"
              ></exam-multiple-choice-simple>
            </template>
          </div>
        </div>
      </div>
    </div>

    <!--矩阵弹框-->
    <dialog-matrix
      :visible.sync="visibleMatrixTip"
    ></dialog-matrix>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import Formula from '../formula'
  import Matrix from '../matrix'
  import editor from '@/mixins/editor'
  import '@/utils/moveAndDrag'
  import hasChildShortQuestion from '@/mixins/hasChildShortQuestion'
  import DialogMatrix from '@/components/exam/DialogMatrix'
  import {
    ExamSingleChoiceSimple,
    ExamMultipleChoiceSimple,
  } from '@components/exam'
  export default {
    name: 'HasChildQuestion',
    components: {
      Formula,
      Matrix,
      ExamSingleChoiceSimple,
      ExamMultipleChoiceSimple,
      DialogMatrix,
    },
    computed: {
      ...mapGetters([
        'currentQuestionIndex',
        'currentQuestion'
      ]),
      magnifyText() {
        return this.frameStatus ? '恢复' : '放大'
      }
    },
    mixins: [editor, hasChildShortQuestion],
    watch: {
      currentQuestion: {
        handler(newVal, oldVal) {
          if (newVal.content !== oldVal.content) {
            this.smallIndex = 0
            this.currentQuestionChange = true
            this.setAllInnerHtml(newVal)
          }
        },
        deep: true
      },
      'currentQuestion.smallContent': {
        handler(newVal) {
          if (!this.currentQuestionChange) {
            this.setInnerHtml(newVal[this.smallIndex])
          }
        },
        deep: true
      }
    },
    data() {
      return {
        visibleTable: [false,false,false,false,false,false,false,false],// 矩阵显隐
        visibleMatrixTip:false, //矩阵提示弹框显隐
        visibleFm: [false,false,false,false,false,false,false,false],  //  公式显隐
        visibleIME: false,  //  输入法显隐
        frameStatus: false, //答题区是否缩放了
        westWidth:'50%', //左侧题干区宽度
        smallIndex: 0,
        //容器对象
        rangeData: {  //  鼠标选中数据
          start: 0,
          end: 0,
          text: ''
        },
        editorContainer: null,
        currentFormulaID: '',  //  当前正在编辑的公式span的id
        blankSpan: '<span class="blankSpan" style="display:inline-block;width:1px;">&nbsp;</span>',
        formulaHtml: '<span id="span_formula_{0}" class="isFormula"></span><span id="span_Temp">&nbsp;</span><span class="blankSpan" style="display:inline-block;width:1px;">&nbsp;</span>',
        matrixHtml: '',
        currentQuestionChange: false,
        addTable:null
      }
    },
    mounted() {
      this.setLayout(2)
      // eslint-disable-next-line no-undef
      this.addTable = addTable('.answerArea', '')
    },
    methods: {
      checkHtml(text) {
        return (text === null || text === 'null' || text === '<br/>' || text === '<br>') ? '' : text
      },
      //分栏设置
      setLayout(quesTag){
        if(quesTag==1){
          //上下分栏
          var myLayout = $('#shortAnswer').layout({
            resizable:true,
            livePaneResizing:true,
            applyDemoStyles: true,
            west__closable:false,
            north__closable:false,
            north__minSize:"20%",
            north__maxSize:"80%",
            //调整大小时调用的函数
            onresize_end : this.changeFck()
          });

          myLayout.sizePane("north", "40%");
          myLayout.resizeAll();
        }else if(quesTag==2){
          //左右分栏
          var myLayout = $('#shortAnswer').layout({
            // resizable:true,
            //livePaneResizing:true,//拖拽时缩放
            resizerTip:"可调整大小",//鼠标移到边框时，提示语
            applyDemoStyles: true,
            west__closable:false,
            west__minSize:"20%",
            west__maxSize:"80%",
            //调整大小时调用的函数
            /*onresize :this.ons(),
            onresize_start : this.onsFun(),
            onresize_end : this.changeFck()*/
          });

          myLayout.sizePane("west", this.westWidth);
         // myLayout.resizeAll();
        }
      },
      //缩放答题区大小
      toggleWin(val){
        if(!this.frameStatus){
          if(val=='left'){
            this.westWidth = '85%'
          }else{
            this.westWidth = '15%'
          }
          this.setLayout(2)
          this.frameStatus =  true
        }else{
          this.westWidth = '50%'
          this.setLayout(2)
          this.frameStatus =  false
        }
      },
      resize(){
        $('.ui-layout-center').width('auto')
      }
    }
  }
</script>
<style lang="scss" scoped>
  $imgUrl: '~@/assets/images/doExam/';
  .short-answer{
    position: absolute;
    top:0;
    right: 0;
    bottom: 0;
    width: 100%;
    line-height: 1.6;
    .ui-layout-west,.ui-layout-center{
      overflow: hidden !important;
    }
    .border0{
      border:none !important;
    }
    .padding0{
      padding: 0 !important;
    }
    .item-title{
      height: 100%;
      .item-head-title{
        width: 100%;
        padding:16px;
        .pull-right{
          float: right;
          .min-btn{
            border-radius: 4px;
            border: 1px solid #ddd;
            font-size: 14px;
            padding: 0 7px;
            color: #666;
            display: inline-block;
            box-sizing: border-box;
            line-height:26px;
            background: #fff;
            i{
              display: inline-block;
              width: 15px;
              height: 7px;
              background: url($imgUrl + "icon-sf.png") left center no-repeat;
              margin-right: 5px;
            }
          }
        }
      }
      .item-ques{
        position: absolute;
        left:20px;
        top:60px;
        height: calc(100% - 60px);
        bottom: 0;
        overflow: auto;
      }
    }

    .sa-function{
      background: #f0f0f0;
      padding: 3px 8px;
      -webkit-touch-callout: none;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      border: 1px solid #ddd;
      border-bottom: none;
      position: relative;
      ul{
        margin-left: 8px;
        overflow: hidden;
        height: 34px;
        li{
          float: left;
          display: inline-block;
          width: 30px;
          border: 1px solid transparent;
          text-align: center;
          line-height: 30px;
          margin-right: 8px;
          a{
            display: inline-block;
            width: 30px;
            &:hover {
              background-color: #ddd;
              border: 1px solid #ccc;
            }
            img{
              position: relative;
              top:5px;
            }
          }
        }
      }
      .count-num{
        top:0;
        right:8px;
        line-height: 41px;
      }
    }
    .sa-input{
      padding: 10px 16px;
      position: absolute;
      right: 0;
      left: 0;
      height: calc(100% - 50px);
      top:60px;
      overflow: auto;
      .sa-title{
        line-height: 1.6;
        margin-bottom: 16px;
        .smallNum{
          display: inline-block;
          padding: 0 5px;
          background-color: #447dff;
          color: #fff;
          font-style: normal;
          border-radius: 3px;
          min-width: 25px;
          text-align: center;
          margin-right: 10px;
        }
      }
      .answerArea{
        border: 1px solid #ddd;
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
        padding: 5px;
        outline: 0;
        overflow: auto;
        background-color: #fafafa;
        min-height: 250px;
        max-height: 500px;
        overflow-y: auto;
        margin-bottom: 25px;
        word-wrap:break-word
      }
    }
    .sa-input-simple{
      padding: 0;
    }

  }
</style>
